<h1 class="page-title mb-5">وحدة منح الجنسية المصرية مقابل الاستثمار</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <p>​يوجد بمقر الهيئة العامة للاستثمار والمناطق الحرة مكتب استقبال طالبي الحصول على الجنسية المصرية للأجانب
          التابع لوحدة فحص طلبات التجنس التابعة لرئاسة مجلس الوزراء وذلك للارتباط الوثيق بين مشروع الجنسية وجذب
          الاستثمارات وهو نظام متبع في كل بلاد العالم، إلا انه في مصر لا يشترط الإقامة لمدة معينة كما هو متبع في قبرص
          واسبانيا وانما يشترط قيام المستثمر بتحويل مبلغ 10 الاف دولار من الخارج الى البنك المركزي المصري كرسوم إدارية
          مع تعبئة طلب الحصول على الجنسية وإرفاق المستندات المطلوبة، ويتم البت في الطلب خلال فترة تتراوح بين 3 الى 6
          شهور و في حال الموافقة عليه من الجهات الأمنية المعنية في ضوء اعتبارات الامن القومي يتم منح المستثمر إقامة
          مؤقتة لمدة ستة أشهر لتنفيذ البرنامج الاستثماري المختار منه سواء كان إنشاء مشروع استثماري او شراء عقار او إيداع
          مبلغ مالي بالعملة الأجنبية كإيرادات مباشرة تؤول الى الخزانة العامة للدولة أو كوديعة في حساب خاص بالبنك المركزي
          ويتم بعد ذلك منح الجنسية المصرية له وللأولاد القصر حتى سن 21 عاماّ بقرار من رئيس مجلس الوزراء.</p>
      </div>
      <div class="col-md-3">
        <app-fix-how-we-can-help></app-fix-how-we-can-help>
      </div>
    </div>
  </div>
</div>